@if (isHistoryCloseButton()) {
    <app-button (clicked)="closeHistory()"
                [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                [buttonText]="'BUTTON.CLOSE' | translate"
                [svgIcon]="ICONS.NAVIGATE_BACK"
                qaTag="close-history-button"/>
} @else {
    <app-button (clicked)="goBackInHistory()"
                (longPress)="showHistoryOverlay()"
                [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                [buttonText]="'BUTTON.HISTORY_BACK'|translate"
                [isLongPressButton]="true"
                [svgIcon]="ICONS.NAVIGATE_BACK"
                qaTag="history-back-button"/>
}
